module.exports = __webpack_public_path__ + "static/media/m_y_12.5b984c16.png";